import { render, staticRenderFns } from "./BaOperatorSent.vue?vue&type=template&id=72711f67&"
import script from "./BaOperatorSent.vue?vue&type=script&lang=js&"
export * from "./BaOperatorSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports